import * as React from 'react';
import { uniqueId } from 'lodash-es';

/**
 * Hook that returns a memoized unique ID.
 * The ID will remain constant throughout the component's lifecycle.
 * @param prefix Optional prefix for the ID
 * @returns A unique string ID
 */
interface UseUniqueIdProps {
  prefix?: string;
}

export const useUniqueId = ({ prefix }: UseUniqueIdProps = {}): string => {
  const id = React.useMemo(() => {
    const prefixStr = prefix ? `${prefix}-` : '';
    return uniqueId(prefixStr);
  }, [prefix]);

  return id;
};
